export default "__VITE_ASSET__Bsil6p30__"